import React from "react";
import { CheckCircleFilled } from "@ant-design/icons";
import Reveal from "../../../../components/Reveal";
import DownloadButtons from "../../../../components/DownloadButtons";
import { useTranslation } from "../../../../i18n/LanguageContext";
import "./style.css";

const featureKeys = [
    "showcase.feature.discover",
    "showcase.feature.progress",
    "showcase.feature.notify",
    "showcase.feature.community",
];

const AppShowcase = () => {
  const { t } = useTranslation();
  return (
    <div className="changed-background app-showcase-bg" id="app">
        <div className="main-content-wrapper">
            <section className="app-showcase">
                {/* Phone mockups — replace the .phone__screen content with
                    real app screenshots (<img>) when available. */}
                <Reveal className="app-showcase__visual">
                    <div className="phone phone--back" aria-hidden="true">
                        <div className="phone__screen phone__screen--alt">
                            <div className="mock-bar" />
                            <div className="mock-hero" />
                            <div className="mock-row" />
                            <div className="mock-row short" />
                            <div className="mock-grid">
                                <span />
                                <span />
                                <span />
                                <span />
                            </div>
                        </div>
                    </div>
                    <div className="phone phone--front">
                        <div className="phone__notch" aria-hidden="true" />
                        <div className="phone__screen">
                            <div className="mock-statusbar">
                                <span>CTRL Events</span>
                                <span className="mock-coins">★ 1250</span>
                            </div>
                            <div className="mock-card mock-card--feature">
                                <span className="mock-tag">Միջոցառում</span>
                                <strong>Ծառերի տնկում</strong>
                                <small>65 կամավոր · Երևան</small>
                            </div>
                            <div className="mock-card">
                                <span className="mock-dot" />
                                <div className="mock-lines">
                                    <i />
                                    <i className="short" />
                                </div>
                            </div>
                            <div className="mock-card">
                                <span className="mock-dot alt" />
                                <div className="mock-lines">
                                    <i />
                                    <i className="short" />
                                </div>
                            </div>
                            <div className="mock-tabbar">
                                <span className="active" />
                                <span />
                                <span />
                                <span />
                            </div>
                        </div>
                    </div>
                </Reveal>

                <Reveal className="app-showcase__content">
                    <span className="section-eyebrow">
                        {t("showcase.eyebrow")}
                    </span>
                    <h2>{t("showcase.heading")}</h2>
                    <p>{t("showcase.desc")}</p>
                    <ul className="app-features">
                        {featureKeys.map((key) => (
                            <li key={key}>
                                <CheckCircleFilled />
                                <span>{t(key)}</span>
                            </li>
                        ))}
                    </ul>
                    <DownloadButtons className="on-dark" />
                </Reveal>
            </section>
        </div>
    </div>
  );
};

export default AppShowcase;
